import { responseEnum } from "./enum";

export default function ErrorHandler(data, setSnackBar) {
  if (data?.payload?.data?.data?.code === responseEnum.FailureCode) {
    setSnackBar("error", data?.payload?.data?.message);
    return false;
  }
  else if (data?.payload?.status === responseEnum.InternalServerCode) {
    setSnackBar("error", data?.payload?.statusText);
    return false;
  }
  else if (data?.payload?.status === responseEnum.ValidationCode) {
    const errors = data?.payload?.data?.errors || data?.payload?.data?.data?.errors;
    if (errors) {
      let valuesArray = Object.values(errors);
      if (valuesArray && valuesArray.length > 0) {
        setSnackBar("error", valuesArray[0]);
      }
    }
    if (data?.payload?.title) {
      setSnackBar("error", data?.payload?.title);
    }
    return false;
  } else {
    return true;
  }
}